import { apiAction } from 'apa/actions'
import * as types from 'catalog/actions/types'
import { fetchMeasureList } from 'catalog/actions/measures'

const ENDPOINT_URL = '/api/attachments/'

export const create = (attachment, callback) => dispatch => dispatch(
  apiAction({
    url: ENDPOINT_URL,
    method: 'POST',
    data: attachment,
    onSuccess: attachment => {
      callback()
      dispatch(fetchMeasureList())
      return {
        type: types.ADD_ATTACHMENT,
        attachment: attachment
      }
    }
  })
)


export const remove = (attachment) => dispatch => dispatch(
  apiAction({
    url: `${ENDPOINT_URL}${attachment.id}/`,
    method: 'DELETE',
    onSuccess: () => {
      dispatch(fetchMeasureList())
      return {
        type: types.ATTACHMENT_DELETED
      }
    } 
  })
)

export const update = (attachment) => dispatch => dispatch(
  apiAction({
    url: `/api/attachments/${attachment.id}/`,
    method: 'PATCH',
    data: attachment,
    onSuccess: attachment => ({
      type: types.UPDATE_ATTACHMENT,
      attachment: attachment
    })
  })
)
